module.exports = __webpack_public_path__ + "static/media/icon-universal.9755bf80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-universal.svg
// module id = 546
// module chunks = 0